"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_TEXTS = void 0;
const types_1 = require("../../types");
exports.BRAND_TEXTS = {
    [types_1.BusinessUnit.BOT]: {
        name: 'Boticário',
        nameWithPrefix: 'o Boticário',
    },
    [types_1.BusinessUnit.EUD]: {
        name: 'Eudora',
        nameWithPrefix: 'a Eudora',
    },
    [types_1.BusinessUnit.EAM]: {
        name: 'Eu Amo Make',
        nameWithPrefix: 'e Eu Amo Make',
    },
    [types_1.BusinessUnit.OUI]: {
        name: 'OUI',
        nameWithPrefix: 'o OUI',
    },
    [types_1.BusinessUnit.MLT]: {
        name: 'Grupo Boticário',
        nameWithPrefix: 'o Grupo Boticário',
    },
};
